// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2K1nu","title":"AfterBackImages_title__3qJ2I","images":"AfterBackImages_images__2KioO"};